
import { defineComponent } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";
import { TextField } from "@/shared/ui";

export default defineComponent({
	name: "InventorySection",
	components: {
		TextField,
	},
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);

		const { updateInventory } = store;

		return {
			characters,
			current,
			updateInventory,
		};
	},
});
